var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelpFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 30.2H22.95V27.3H20.05V30.2ZM21.5 7C13.496 7 7 13.496 7 21.5C7 29.504 13.496 36 21.5 36C29.504 36 36 29.504 36 21.5C36 13.496 29.504 7 21.5 7ZM21.5 33.1C15.1055 33.1 9.9 27.8945 9.9 21.5C9.9 15.1055 15.1055 9.9 21.5 9.9C27.8945 9.9 33.1 15.1055 33.1 21.5C33.1 27.8945 27.8945 33.1 21.5 33.1ZM21.5 12.8C18.2955 12.8 15.7 15.3955 15.7 18.6H18.6C18.6 17.005 19.905 15.7 21.5 15.7C23.095 15.7 24.4 17.005 24.4 18.6C24.4 21.5 20.05 21.1375 20.05 25.85H22.95C22.95 22.5875 27.3 22.225 27.3 18.6C27.3 15.3955 24.7045 12.8 21.5 12.8Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpFilled);
export default __webpack_public_path__ + "static/media/icon-help-filled.f0822027c939111f0e06351ba84c3f73.svg";
export { ForwardRef as ReactComponent };